import get from 'lodash.get';

const getUserPartnerId = (rootState) => get(rootState, 'user.userData.partnerId', null);

export default getUserPartnerId;
